// dialog to display all selected items
// and choose whether to accept all or reject all
import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import Container from "@mui/material/Container";
import BulkApprovalAccordion from "./BulkApprovalAccordion.component";
import Button from "@mui/material/Button";
import { DialogActions } from "@mui/material";
import { BulkApprovalConfirmationDialog } from "./BulkApprovalConfirmationDialog.component";

export function BulkApprovalDialog(props) {
  const [approval, setApproval] = useState();
  const handleClose = () => {
    props.setOpen(false);
  };

  //confirmation dialog handler and stat
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const handleOpenConfirmationDialog = (approval) => {
    setApproval(approval);
    setOpenConfirmationDialog(true);
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      style={{
        height: "90%",
      }}
      fullWidth
      PaperProps={{ sx: { borderRadius: "20px" } }}
    >
      <Box
        sx={{
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Container
          component="main"
          maxWidth="sm"
          sx={{
            marginTop: 4,
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          {/* Dialog title */}
          <Typography component="h1" variant="h5">
            Bulk Approval
          </Typography>
          {/* map through all items to display them in accordions */}
          {props.selectedRowsSummary.length > 0 ? (
            "Kindly confirm that following are the sample requests that you want to approve or reject in bulk"
          ) : (
            <div style={{ marginTop: "20px" }}>
              Kindly select items to be Approved or Rejected
            </div>
          )}
          {props.selectedRowsSummary.map((rowData, index) => {
            return (
              <BulkApprovalAccordion
                rowData={rowData}
                index={index}
                key={index}
              />
            );
          })}
        </Container>
      </Box>

      {/* dynamic dialog actions based on whether any items were selected or not */}
      <DialogActions>
        {props.selectedRowsSummary.length > 0 ? (
          <>
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{
                padding: "10px 20px",
                m: "0 20px 20px 0",
                fontSize: "14px",
                // backgroundColor: "#c7ab79",
              }}
              onClick={() => handleOpenConfirmationDialog("Rejected")}
            >
              Reject
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{
                padding: "10px 50px",
                m: "0 20px 20px 0",
                fontSize: "14px",
                backgroundColor: "#c7ab79",
                "&:hover": {
                  backgroundColor: "#c4943f",
                },
              }}
              onClick={() => handleOpenConfirmationDialog("Accepted")}
            >
              Approve
            </Button>{" "}
          </>
        ) : (
          <Button
            size="small"
            variant="contained"
            sx={{
              padding: "10px 50px",
              m: "0 20px 20px 0",
              fontSize: "14px",
              backgroundColor: "#c7ab79",
              "&:hover": {
                backgroundColor: "#c4943f",
              },
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>
        )}
      </DialogActions>

      {/* import bulk approval confirmation dialog */}
      <BulkApprovalConfirmationDialog
        open={openConfirmationDialog}
        setOpen={setOpenConfirmationDialog}
        handleOpen={handleOpenConfirmationDialog}
        handleSubmit={props.handleSubmit}
        approval={approval}
        isSubmitting={props.isSubmitting}
      />
    </Dialog>
  );
}
